import _asyncToGenerator from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
export default {
  namespaced: true,
  state: {
    // 用户信息
    info: {}
  },
  getters: {
    /**
     * @description 返回当前用户信息
     * @param {Object} state state
     */
    currUserInfo: function currUserInfo(state) {
      return state.info;
    }
  },
  actions: {
    updateEmail: function updateEmail(_ref, email) {
      var state = _ref.state,
          dispatch = _ref.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  state.info.email = email;
                  resolve();

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 设置用户数据
     * @param {Object} context
     * @param {*} info info
     */
    set: function set(_ref3, info) {
      var state = _ref3.state,
          dispatch = _ref3.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // store 赋值
                  state.info = info; // 持久化

                  _context2.next = 3;
                  return dispatch('u8sdk/db/set', {
                    dbName: 'sys',
                    path: 'user.info',
                    value: info,
                    user: true
                  }, {
                    root: true
                  });

                case 3:
                  // end
                  resolve();

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 从数据库取用户数据
     * @param {Object} context
     */
    load: function load(_ref5) {
      var state = _ref5.state,
          dispatch = _ref5.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return dispatch('u8sdk/db/get', {
                    dbName: 'sys',
                    path: 'user.info',
                    defaultValue: {},
                    user: true
                  }, {
                    root: true
                  });

                case 2:
                  state.info = _context3.sent;
                  // end
                  resolve();

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }
};